import type { SsoConfig } from './types';

/**
 * SF-4656 — a company's SSO state as the company page sees it.
 * - 'none': no SSO setup.
 * - 'off': a setup exists but is switched off (nobody can sign in with it).
 * - 'live': a setup that is switched on (people can sign in with it).
 * Only 'live' locks the Feature Flags SSO switch on.
 */
export type SsoState = 'none' | 'off' | 'live';

export const ssoStateOf = (config: SsoConfig | null | undefined): SsoState =>
  !config ? 'none' : config.isEnabled === true ? 'live' : 'off';
